import getConfig from 'next/config';
export function akamaiImageLoader(_ref) {
  var src = _ref.src,
    width = _ref.width;
  return "".concat(src, "?imwidth=").concat(width);
}
export function isIVMEnabled() {
  var _ref2 = getConfig() || {},
    _ref2$publicRuntimeCo = _ref2.publicRuntimeConfig,
    publicRuntimeConfig = _ref2$publicRuntimeCo === void 0 ? {} : _ref2$publicRuntimeCo;
  var NEXT_IMAGE_UNOPTIMIZED = publicRuntimeConfig.NEXT_IMAGE_UNOPTIMIZED;
  return NEXT_IMAGE_UNOPTIMIZED === 'true';
}